export var COURSE_PROGRESS_UPDATED = 'COURSE_PROGRESS_UPDATED';